import { SESSION_ERROR_KEY } from '@constants/index'
import { CUSTOM_EVENT_NAME, SessionError } from '@typesApp/AppEvent'

type EventDetail = {
  type: 'onSessionError'
  payload?: SessionError
}

type AppEventEmitter = {
  sessionExpired: () => void
  sessionTransitioned: () => void
}

/**
 * Helper to emit events for AppEventListener
 */
const eventEmitter = (): AppEventEmitter => {
  const dispatch = (detail: EventDetail) => {
    document.dispatchEvent(
      new CustomEvent(CUSTOM_EVENT_NAME.APP, {
        detail,
      })
    )
  }

  const sessionExpired = () => {
    dispatch({
      type: 'onSessionError',
      payload: {
        errorKey: SESSION_ERROR_KEY.SESSION_EXPIRED,
        isInternal: true, // indicate this is an internal event and not from commerce F/E
      },
    })
  }

  const sessionTransitioned = () => {
    dispatch({
      type: 'onSessionError',
      payload: {
        errorKey: SESSION_ERROR_KEY.SESSION_TRANSITIONED,
        isInternal: true,
      },
    })
  }

  return {
    sessionExpired,
    sessionTransitioned,
  }
}

export const appEventEmitter = eventEmitter()
